import React from "react";
import {
  Box,
  Typography,
  Stack,
  IconButton,
  CircularProgress,
  LinearProgress,
} from "@mui/material";
import CheckCircle from "@mui/icons-material/CheckCircle";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";

export default function ChecklistPanel({
  checklist = null,
  loading = false,
  fieldLoading = {},
  onToggle,
  readOnly = false,
  height = 300,
}) {
  const fields = checklist
    ? [
        { key: "info_vehiculo", label: "Info vehículo", value: !!checklist.info_vehiculo },
        { key: "info_agencia", label: "Info agencia", value: !!checklist.info_agencia },
        { key: "precio", label: "Precio", value: !!checklist.precio },
        { key: "reserva", label: "Reserva", value: !!checklist.reserva },
        { key: "financiaciones", label: "Financiaciones", value: !!checklist.financiaciones },
        { key: "modelos_alt", label: "Modelos alternativos", value: !!checklist.modelos_alt },
        { key: "metodos_de_pago", label: "Métodos de pago", value: !!checklist.metodos_de_pago },
      ]
    : [];

  // Solo mostrar loading si no hay checklist cargado
  const showInitialLoading = loading && !checklist;
  const completed = fields.filter((f) => f.value).length;
  const total = fields.length;
  const progress = total ? Math.round((completed / total) * 100) : 0;

  return (
    <Box sx={{ p: 2, height, overflow: "auto" }}>
      {showInitialLoading && (
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          Cargando checklist...
        </Typography>
      )}

      {!showInitialLoading && !checklist && (
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          No se encontró checklist para esta asignación.
        </Typography>
      )}

      {checklist && (
        <>
          <Box sx={{ mb: 1.4 }}>
            <Typography sx={{ fontSize: 11, color: "#50617f", fontWeight: 800, mb: 0.8 }}>
              {completed} de {total} completados
            </Typography>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                height: 6,
                borderRadius: 999,
                bgcolor: "#e8edf5",
                "& .MuiLinearProgress-bar": {
                  borderRadius: 999,
                  bgcolor: "#2563eb",
                },
              }}
            />
          </Box>

          <Stack spacing={0} sx={{ pt: 0 }}>
            {fields.map((f) => (
              <Box
                key={f.key}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  minHeight: 38,
                  borderBottom: "1px solid #eef2f7",
                  "&:last-of-type": {
                    borderBottom: 0,
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: 14,
                    fontWeight: 700,
                    textDecoration: f.value ? "line-through" : "none",
                    textDecorationThickness: f.value ? "2px" : undefined,
                    textDecorationColor: f.value ? "currentColor" : undefined,
                    textDecorationSkipInk: "none",
                    color: f.value ? "#8a94a6" : "#15213b",
                    transition: "color 160ms ease",
                  }}
                >
                  {f.label}
                </Typography>

                <IconButton
                  aria-label={f.label}
                  onClick={() => {
                    if (!readOnly && onToggle) onToggle(f.key);
                  }}
                  size="small"
                  disabled={readOnly || Boolean(fieldLoading[f.key])}
                  sx={{ width: 30, height: 30 }}
                >
                  {Boolean(fieldLoading[f.key]) ? (
                    <CircularProgress size={18} />
                  ) : f.value ? (
                    <CheckCircle sx={{ fontSize: 24, color: readOnly ? "action.disabled" : "#2563eb" }} />
                  ) : (
                    <RadioButtonUnchecked sx={{ fontSize: 24, color: readOnly ? "action.disabled" : "#9aa6b8" }} />
                  )}
                </IconButton>
              </Box>
            ))}
          </Stack>
        </>
      )}
    </Box>
  );
}
